const firebaseConfig = {
  apiKey: "AIzaSyA_3yax2jZMvGwV4ziqN7CwvF7pmVodxhg",
  authDomain: "assignment-10-79f1f.firebaseapp.com",
  projectId: "assignment-10-79f1f",
  storageBucket: "assignment-10-79f1f.appspot.com",
  messagingSenderId: "447126136181",
  appId: "1:447126136181:web:ab4a6f5435940d83d25f3c"
};

  export default firebaseConfig;